// extracted by mini-css-extract-plugin
module.exports = {"playButton":"_d496f1b","touch":"_b4d3f73"};